<template>
  <div>
    <div
      :key="item.label"
      v-for="item in defaultNaviItems"
    >
      <p
        class="a"
      >
        <a
          :href="item.href"
          target="_blank"
          :title="item.title"
        >
          {{ item.label }}
        </a>
      </p>
      <p
        class="devider"
      >
        /
      </p>
    </div>
    <v-btn v-if="loggedin" @click="logout" class="primary">
     {{ $vuetify.lang.t("$vuetify.kba.header.logout.label").toUpperCase() }}
    </v-btn>

  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {

    }
  },
  props: {
    /*navigation: {
      type: Object,
      required: true
    },*/
    defaultNaviItems: {
      type: Array,
      required: true
    },
/*    alternativeLanguage: {
      type: Object,
      required: true
    },*/
    store: {
      type: String,
      default: 'antragsformular'
    }
  },
  computed: {
    loggedin: {
      get() {
        return this.$store.getters['loggedin/loggedin']
      },
      set(value) {
        this.$store.commit( 'loggedin/loggedin', value)
      }
    }
  },
  methods: {
    t(value) {
      return this.$vuetify.lang.t('$vuetify.' + value)
    },
    logout() {
      this.$http.post('logout').then(() => {
        this.$router.go()
        this.loggedin = false
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/wmi-styles.scss";

ul {
  text-align: right;
}

.devider {
  margin: 0 1.5em;
  color: $color-main-light;
  font-weight: 600;
}

@media only screen and (max-width: 1400px) {
  .devider {
    margin: 0 0.5em;
  }
}

div {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

a {
  color: $color-main;
  text-decoration: none;
  text-transform: none;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  display: block;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.1em;
    background-color: $color-main;
    opacity: 0;
    transition: transform 300ms;
  }
}

p a {
  overflow: hidden;

  &::after {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
  }

  &:hover::after,
  &:focus::after {
    transform: translate3d(0, 0, 0);
  }
}
</style>
